import { render } from "./FlowField.vue?vue&type=template&id=635739ee"
import script from "./FlowField.vue?vue&type=script&lang=js"
export * from "./FlowField.vue?vue&type=script&lang=js"

import "./FlowField.vue?vue&type=style&index=0&id=635739ee&lang=css"
script.render = render

export default script